import { ThemeType, useTheme } from "@/mds/themes/theme-context";
import ColorHash from "color-hash";

export function useThemedCollectionColors(collectionId?: string) {
  const { theme, themeType } = useTheme();

  if (!collectionId)
    return {
      bgColor: theme.colors.background.button.chip.default,
      textColor: theme.colors.text.secondary,
      iconColor: theme.colors.icon.primary,
    };

  const lightBgColorHash = new ColorHash({ lightness: 0.91, saturation: 0.92 });
  const lightTextColorHash = new ColorHash({ lightness: 0.31, saturation: 1.0 });
  const lightIconColorHash = new ColorHash({ lightness: 0.57, saturation: 1.0 });

  const darkBgColorHash = new ColorHash({ lightness: 0.2, saturation: 0.59 });
  const darkTextColorHash = new ColorHash({ lightness: 0.95, saturation: 1.0 });
  const darkIconColorHash = new ColorHash({ lightness: 0.7, saturation: 1.0 });

  const lightBgColor = lightBgColorHash.hex(collectionId);
  const lightTextColor = lightTextColorHash.hex(collectionId);
  const lightIconColorHsl = lightIconColorHash.hsl(collectionId);
  const lightIconColor = `hsl(${lightIconColorHsl[0]}, ${lightIconColorHsl[1] * 100}%, ${(lightIconColorHsl[2] - 0.15) * 100}%)`;

  const darkBgColor = darkBgColorHash.hex(collectionId);
  const darkTextColor = darkTextColorHash.hex(collectionId);
  const darkIconColorHsl = darkIconColorHash.hsl(collectionId);
  const darkIconColor = `hsl(${darkIconColorHsl[0]}, ${darkIconColorHsl[1] * 100}%, ${(darkIconColorHsl[2] - 0.15) * 100}%)`;

  const bgColor = themeType === ThemeType.Harvest ? lightBgColor : darkBgColor;
  const textColor = themeType === ThemeType.Harvest ? lightTextColor : darkTextColor;
  const iconColor = themeType === ThemeType.Harvest ? lightIconColor : darkIconColor;

  return { bgColor, textColor, iconColor };
}
